<template>
  <div>
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="$t('unitChanges.changeHeader')"
        :title= "getTitle"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"
    >
      <b-form @submit.prevent="applyChange">
        <b-form-input v-if="changeRequested === 'description'"
                      id="input-description"
                      v-model="unit.description"
                      :placeholder="$t('unitChanges.descriptionPlaceholder')">
        </b-form-input>
        <b-form-input v-if="changeRequested === 'email'"
                    id="input-email"
                    v-model="unit.contact.email"
                    type="email"
                    :placeholder="$t('unitChanges.email')">
        </b-form-input>
        <b-form-input v-if="changeRequested === 'contactName'"
                    id="input-contactName"
                    v-model="unit.contact.contactName"
                    required
                    :placeholder="$t('unitChanges.name')">
        </b-form-input>
        <b-form-input v-if="changeRequested === 'phoneNumber'"
            id="input-phoneNumber"
            v-model="unit.contact.phoneNumber"
            placeholder="Phone Number">
        </b-form-input>
        <b-button type="submit" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
        <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>

import store from "../store/store";
import unitApi from "@/services/unitApi";
import router from "@/router";

export default {
  name: 'ChangeUnitDetails',
  props: {
    changeRequested: { type: String }
  },
  data() {
    return {
      text: '',
      unit: {
        contact: {
          contactName: "",
          phoneNumber: "",
          email: ""
        }
      }
    }
  },
  mounted() {
    this.unit.contact.contactName = store.getters.getUnitContactName
    this.unit.contact.email = store.getters.getUnitContactEmail
    this.unit.contact.phoneNumber = store.getters.getUnitContactPhone
  },

  computed: {
    getTitle() {
      if (this.changeRequested === "contactName") {
        return this.$t('unitChanges.contactNameTitle')
      } else if (this.changeRequested === "email") {
        return this.$t('unitChanges.emailTitle')
      } else {
        return this.$t('unitChanges.phoneNumberTitle')
      }
    },
    getLabel() {
      if (this.changeRequested === "contactName") {
        return this.$t('unitDetails.contactName')
      } else if (this.changeRequested === "email") {
        return this.$t('unitDetails.contactEmail')
      } else {
        return this.$t('unitDetails.phoneNumber')
      }
    }
  },
  methods: {
    async applyChange(evt) {
      evt.preventDefault()
      try {
        await unitApi.updateUnit(store.getters.getTenantGuid, this.unit)
        router.push({name: 'Unit'})
      }catch(e){
        if(e.response.status === 409 || e.response.status === 400) {
          this.$bvToast.toast( e.response.data.message, {
            title: this.$t('unitDetailChangeFailed.detailsTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
        else {
              this.$bvToast.toast( this.$t('unitDetailChangeFailed.unitDetailsUpdateErrorMsg'), {
                title: this.$t('unitDetailChangeFailed.detailsTitle'),
                autoHideDelay: 10000,
                toaster: "b-toaster-top-center",
                variant: "warning",
                append: false,
                solid: false
              })
            }
      }
    },
    onCancel() {
      router.push({ name: 'Unit'})
    }
  }
}
</script>
